import Modal from "react-modal";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

export default function CategoryModal({
  modalIsOpen,
  Openchanger,
  setActiveOrder,
}) {
  const [activeCat, setActiveCat] = useState();
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "400px",
      height: "270px",
      border: "0px",
      overflowY: "hidden",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };

  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "34rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(95vh - 1rem)",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  Modal.setAppElement("#root");

  function afterOpenModal() {}
  function closeModal() {
    Openchanger(false);
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
        id={"factor-modal"}
      >
        <div className="header-modal-wrapper"></div>
        <div className={"container"} id={"factor-mbody"}>
          <div className="remove-cross" onClick={() => Openchanger(false)}>
            &#10006;
          </div>
          <div>
            <div className="select-box-row-sheet">
              <input
                id={"low-price-low-cap"}
                type={"radio"}
                onChange={() => setActiveCat(1)}
                name="category-sheet-filter"
              />
              <label htmlFor="low-price-low-cap">
                ارزان‌ترین قیمت در حجم کم
              </label>
            </div>
            <div className="select-box-row-sheet">
              <input
                id={"low-price-high-cap"}
                type={"radio"}
                onChange={() => setActiveCat(2)}
                name="category-sheet-filter"
              />
              <label htmlFor={"low-price-high-cap"}>
                ارزان‌ترین قیمت در حجم زیاد
              </label>
            </div>
            <div className="select-box-row-sheet">
              <input
                id={"high-price-low-cap"}
                type={"radio"}
                onChange={() => setActiveCat(3)}
                name="category-sheet-filter"
              />
              <label htmlFor={"high-price-low-cap"}>
                گرانترین قیمت در حجم کم
              </label>
            </div>
            <div className="select-box-row-sheet">
              <input
                id={"high-price-high-cap"}
                type={"radio"}
                onChange={() => setActiveCat(4)}
                name="category-sheet-filter"
              />
              <label htmlFor={"high-price-high-cap"}>
                گرانترین قیمت در حجم زیاد
              </label>
            </div>
          </div>
          <div className="button-wrapper-cat">
            <button
              className="form-input-button-custom"
              onClick={() => {
                setActiveOrder(activeCat);
                closeModal();
              }}
            >
              اعمال دسته بندی
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
